/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import Button from '@mui/material/Button'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { clearFormStatus } from '../../../irmlib/src/redux'
import { doesFileSizeExceed } from './UploadButton'

// Define styled component outside of the functional component
const TextButton = styled(Button)`
  && {
    width: fit-content;
    // padding: 17px 0 0 0;
    justify-content: flex-start;
    padding-left: 0
  }
`
// const NameLabel = styled.label`
//     display: flex;
//     width: 12vw;
//     justify-content: left;
//     color: #2E8B57;
// `
const ErrorLabel = styled.label`
    display: flex;
    width: 19vw;
    justify-content: flex-start;
    color: red;
    margin-top: 5px;
    font-size: 11px;
`
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
})



export const InputFileUpload = (props) => {
//   const [selectedImage, setSelectedImage] = useState(null)
  const { t } = useTranslation()
  const { onImageCapture, error, setError, maxSize, allowedFormats } = props
  // const [selectedImageLabel, setSelectedImageLabel] = useState(null)
  const [fileError, setFileError] = useState(null)

  const handleImageChange = (event) => {
    if (event?.target?.files[0]?.length !== 0) {
      const file = event.target.files[0]
      const maxSizeInBytes = maxSize * 1024 * 1024 // coverting file size in bytes
      const isFileSizeExceeded = doesFileSizeExceed(file.size, maxSizeInBytes)
      const fileType = file.type.toLowerCase()
      const fileName = file.name.toLowerCase()
      if (allowedFormats.includes('JPG') && allowedFormats.includes('JPEG') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg' && isFileSizeExceeded) {
        setFileError(t('demo.uploadJpgTypeandSizeErr', { noOfMb: maxSize }))
        // setSelectedImageLabel(null)
        onImageCapture(null)
        clearFormStatus()
      } else if (allowedFormats.includes('JPG') && allowedFormats.includes('JPEG') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg') {
        setFileError(t('demo.uploadJpgType'))
        // setSelectedImageLabel(null)
        onImageCapture(null)
        clearFormStatus()
      } else if (isFileSizeExceeded) {
        setFileError(t('demo.fileSizeExceeded', { noOfMb: maxSize }))
        // setSelectedImageLabel(null)
        onImageCapture(null)
        clearFormStatus()
      } else {
        // setSelectedImageLabel(file.name)
        onImageCapture(file)
        setError('')
        setFileError(null)
        clearFormStatus()
      }
    } else {
      return null
    }
  }
  return (
    <div>
      <TextButton 
    //   onClick={handleUploadButtonClick}
        component="label"
        role={undefined}
        tabIndex={-1}
    >{`${t('buttons.ChangeReferanceImage')} `}
        <VisuallyHiddenInput 
          type="file" 
          accept="image/*"
          onChange={handleImageChange}
        />
      </TextButton>
      {/* {selectedImageLabel && <NameLabel>{selectedImageLabel}</NameLabel>} */}
      {(error || fileError) && <ErrorLabel>{error || fileError}</ErrorLabel>}
    </div>
  )
}
InputFileUpload.propTypes = {
  onImageCapture: PropTypes.func,
  error: PropTypes.string,
  setError: PropTypes.func.isRequired
}

InputFileUpload.defaultProps = {
  onImageCapture: null,
  error: null,
  setError: () => {}
}